import * as services from 'services/templates';

export const SET_ERROR = 'templates/SET_ERROR';
export const CLEAR_ERROR = 'templates/CLEAR_ERROR';
export const REQUEST_STARTED = 'templates/REQUEST_STARTED';
export const REQUEST_COMPLETED = 'templates/REQUEST_SUCCESSFUL';
export const SET_TEMPLATES = 'templates/SET_TEMPLATES';
export const EDIT_TEMPLATE = 'templates/EDIT_TEMPLATE';
export const GET_TEMPLATES_FROM_SERVER = 'templates/GET_TEMPLATES_FROM_SERVER';
export const DELETE_TEMPLATE = 'templates/DELETE_TEMPLATE';
export const ADD_TEMPLATE = 'templates/ADD_TEMPLATE';
export const SET_NEW_TEMPLATE_ID = 'templates/SET_NEW_TEMPLATE_ID';
export const SEARCH_IN_TEMPLATES = 'templates/SEARCH_IN_TEMPLATES';

export const setError = error => ({
  type: SET_ERROR,
  error,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const requestStarted = () => dispatch => {
  dispatch(clearError());
  dispatch({ type: REQUEST_STARTED });
};

export const requestCompleted = () => ({
  type: REQUEST_COMPLETED,
});

export const setTemplates = templates => ({
  type: SET_TEMPLATES,
  templates,
});

export const setNewTemplateId = newTemplateId => ({
  type: SET_NEW_TEMPLATE_ID,
  newTemplateId,
});

export const searchInTemplates = searchString => ({
  type: SEARCH_IN_TEMPLATES,
  searchString,
});

export const getTemplatesFromServer = () => dispatch => {
  dispatch(requestStarted);
  services
    .getTemplates()
    .then(emails => {
      dispatch(setTemplates(emails));
      dispatch(requestCompleted());
    })
    .catch(() => {
      dispatch(setError('Error fetching templates'));
      dispatch(requestCompleted());
    });
};

export const getTemplatesInCategoryFromServer = categoryId => dispatch => {
  dispatch(requestStarted);
  services
    .getTemplateInCategory(categoryId)
    .then(emails => {
      dispatch(setTemplates(emails));
      dispatch(requestCompleted());
    })
    .catch(() => {
      dispatch(setError('Error fetching templates'));
      dispatch(requestCompleted());
    });
};

export const addTemplate = template => dispatch => {
  dispatch(requestStarted);
  services
    .addTemplate(template)
    .then(({ success, id }) => {
      if (success) {
        dispatch(getTemplatesFromServer());
        dispatch(setNewTemplateId(id));
      } else {
        dispatch(setError('Error adding template'));
      }
      dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};

export const editTemplate = template => dispatch => {
  dispatch(requestStarted);
  services
    .editTemplate(template)
    .then(({ success }) => {
      if (success) dispatch(getTemplatesFromServer());
      else dispatch(setError('Error updating template'));
      dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};

export const deleteTemplate = templateId => dispatch => {
  dispatch(requestStarted);
  services
    .deleteTemplate(templateId)
    .then(({ success }) => {
      if (success) dispatch(getTemplatesFromServer());
      else dispatch(setError('Error deleting template'));
      dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};
